// extracted by mini-css-extract-plugin
export var container = "_ff-0";
export var icon = "_ff-1";
export var text = "_ff-2";